// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1eEFK","disabled":"FileBtn_disabled__2YyQv","warn":"FileBtn_warn__2Uhdj","fade":"FileBtn_fade__3Sh5d"};